<template>
  <div>
    <div v-loading="$wait.waiting(_uid)" class="card-wrapper">
      <div class="w-full flex justify-between gap-7 md:flex-row flex-col">
        <div
          v-for="(stats, index) in statsCards"
          :key="index"
          class="card-offset md:w-1/4 w-full"
        >
          <el-tooltip content="stats.title" placement="top">
            <div slot="content">
              {{ stats.tooltip }}
            </div>

            <div
              class="card-clicker cursor-pointer"
              :class="stats.count ? 'opacity-100' : 'opacity-30'"
              @click="toggle(stats.id)"
            >
              <stats-card :class="getStatus(stats)">
                <div
                  slot="header"
                  class="icon-big text-center"
                  :class="`icon-${stats.type}`"
                >
                  <i :class="stats.active ? stats.icon : stats.iconInactive" />
                </div>

                <div slot="content" class="numbers">
                  <p class="text-xl lg:text-2xl">
                    {{ stats.title }}
                  </p>
                  {{ stats.count }}
                </div>

                <div slot="footer" class="stats">
                  <p class="card-footer-text text-xl">
                    {{ stats.active ? "Showing trainees" : "Show trainees" }}
                  </p>
                </div>
              </stats-card>
            </div>
          </el-tooltip>
        </div>
      </div>

      <div v-if="active" class="card w-full">
        <div class="card-content">
          <div class="mt-s">
            <div class="mb-5 w-full">
              <fieldset>
                <div class="form-group">
                  <input
                    v-model="searchQuery"
                    type="search"
                    class="form-control form-search"
                    placeholder="Type to find what you are looking for"
                    aria-controls="datatables"
                    autofocus
                  />
                </div>
              </fieldset>
            </div>

            <div>
              <el-table
                class="table-striped"
                :data="queriedData"
                :default-sort="defaultSort"
                border
                style="width: 100%"
              >
                <el-table-column
                  sortable
                  :sort-orders="['ascending', 'descending']"
                  prop="fullName"
                  label="Name"
                >
                  <template #default="scope">
                    <div class="flex">
                      <div class="mr-3">
                        <router-link
                          :to="{
                            name: 'companies_users@show',
                            params: { id: scope.row.id },
                            query: { tab: tab },
                          }"
                        >
                          {{ scope.row.fullName }}
                        </router-link>
                      </div>
                      <div v-if="scope.row.suspendSetting.status">
                        <Icon :type="'suspend'" class="text-info" />
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- <div class="flex justify-between items-center">
              <div>
                <p class="category">
                  Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                </p>
              </div>

              <p-pagination
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
              />

              <div>
                <el-select
                  v-model="pagination.perPage"
                  class="select-default"
                  placeholder="Per page"
                >
                  <el-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    class="select-default"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import { Table, TableColumn } from "element-ui";
import StatsCard from "@components/UIComponents/Cards/StatsCard.vue";
import tableConfig from "@providers/table";
// import PPagination from "@components/UIComponents/Pagination.vue";
import MyService from "@app/services/my";
import cards from "@providers/trainingStatusCards.json";
import Icon from "@components/UIComponents/TopicIcon/Icon";

Vue.use(Table);
Vue.use(TableColumn);

export default {
  components: {
    StatsCard,
    Icon,
    // PPagination,
  },
  data() {
    return {
      tab: "schedule",
      statsCards: [],
      tableData: [],
      tableColumns: [
        {
          prop: "fullName",
          label: "Name",
          minWidth: 300,
        },
      ],
      ...tableConfig.data,
      defaultSort: { prop: "fullName", order: "ascending" },
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    active() {
      const toggled = this.statsCards.find(({ active }) => active);
      return toggled && toggled.id;
    },
    ...tableConfig.computed,
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      const statsCards = await MyService.trainingStatus();
      this.statsCards = this.mergeData(statsCards);
      this.resolveActive();
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("errorStore", ["addNewError"]),
    mergeData(statsCards) {
      return statsCards.map((item) => {
        return { ...item, ...cards[item.id] };
      });
    },
    resolveActive() {
      let active = "current";
      let priority = [];

      this.statsCards.forEach((element) => {
        priority[element.priority] = {
          count: element.count,
          priority: element.priority,
          id: element.id,
        };
      });

      const stat = priority
        .filter((item) => {
          return item.count;
        })
        .shift();

      if (!stat) {
        active = null;
        return;
      }

      active = stat.id;
      this.toggle(active);
    },
    toggle(id) {
      const foundCard = this.statsCards.find(({ id: cardId }) => id === cardId);

      if (!foundCard.count) {
        return;
      }

      this.tableData = foundCard.list;
      this.tab = foundCard.tab;

      return (this.statsCards = this.statsCards.map((card) => {
        card.active = card.id === foundCard.id;

        return card;
      }));
    },
    getStatus(stats) {
      if (!stats.count) {
        return;
      }
      return stats.active
        ? `border card-${stats.type}-active`
        : `border card-${stats.type}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.card-wrapper {
  display: flex;
  margin: 0;
  flex-wrap: wrap;

  @media screen and (max-width: 1024px) {
    .row {
      margin: 0;
    }
  }
}

.card-offset {
  margin-bottom: 15px;
  .card-content {
    min-height: 110px;
  }
}
.card-footer-text {
  margin: 0;
  min-height: 17px;
}

.card-clicker {
  display: grid;
  height: 100%;
  .card .numbers p {
    min-height: 44px;
  }
}
</style>
